import Http from "@/commons/Http";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";

export default {
    async downloadZip(url, data = null, filename = 'arquivos.zip', method = 'POST'){

        const config = {
            responseType: 'blob',
            timeout : 0,
            headers: {'Content-Type': 'application/json'}
        };

        let promise;
        if(method === 'POST'){
            promise = Http.post(url, data, config);
        }else{
            promise = Http.get(url, config);
        }

        return promise.then(response => {
            const a = document.createElement("a");
            const blob = new Blob([response], {type: "application/zip"});
            url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(e => {
            e.text().then(erro => {
                const error = JSON.parse(erro);
                ToastMessageBusiness.showError(error.message);
                if(error.field){
                    ToastMessageBusiness.showError(error.field);
                }
                throw error;
            });
        });

    },
}